import React from 'react'
import SavingsAccountForm from './Components/SavingsAccountForm'

const SavingsAccount = () => {
    return (
        <div>
            {/* x---------------------------------x Savings Account Form Section x---------------------------------x */}
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="card h-100">
                        <div className="card-header justify-content-between">
                            <h2 className="fs-5 fw-semibold">Open New Savings accounts</h2>
                        </div>
                        <div className="rounded-4 mb-3 mb-sm-0 bg-white">
                            <div className="card-body rounded p-4">
                                {/* x---------------------------------x Savings Account Form x---------------------------------x */}
                                <SavingsAccountForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default SavingsAccount